module.exports = __webpack_public_path__ + "img/C03TechPVPGiftOfDruantia_ua.b93d4fd4.webp";